import { Link } from "components/core/index";
import LOGO from "assets/images/logo.png";
import LOGO_EXTENDS from "assets/images/logo-extends.png";
import LOGO_DEFAULT from "assets/images/logo-default.png";

export const Logo = ({
  maxWidth = 120,
  width = 120,
  className = "img-fluid w-100",
  margin = "auto",
  type = "default",
  isNotLink,
}) => {
  let logo;
  switch (type) {
    case "square":
      logo = LOGO_DEFAULT;
      break;
    case "extends":
      logo = LOGO_EXTENDS;
      break;

    default:
      logo = LOGO;
      break;
  }
  // isExtends ? LOGO_EXTENDS : LOGO

  if (isNotLink) {
    return (
      <a href={null}>
        <img
          src={logo}
          alt="logo"
          className={className}
          style={{ maxWidth, width, margin }}
        />
      </a>
    );
  }

  return (
    <Link to="/admin">
      <img
        src={logo}
        alt="logo"
        className={className}
        style={{ maxWidth, width, margin }}
      />
    </Link>
  );
};
